import { AxiosInstance } from 'axios'

export type KeaMessageVote = 'up' | 'down'

export interface IKeaMessageVote {
  messageId: string
  vote: KeaMessageVote
  feedbackText: string | null
}

export interface IPutVotePayload {
  sessionId: string
  vote: KeaMessageVote
  feedbackText?: string | null
  messageContent: string
}

export function keaMessageVotesApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/kea'
  return {
    putVote(messageId: string, payload: IPutVotePayload) {
      return api.put<IKeaMessageVote>(
        `${baseUrl}/messages/${messageId}/vote`,
        payload
      )
    },
    deleteVote(messageId: string) {
      return api.delete<void>(`${baseUrl}/messages/${messageId}/vote`)
    },
    getSessionVotes(sessionId: string) {
      return api.get<IKeaMessageVote[]>(
        `${baseUrl}/sessions/${sessionId}/messages/votes`
      )
    }
  }
}
